import { Component, OnInit, Input } from "@angular/core";
import { PermissionUrlService } from "../../../services/permissions.service"; //"./../../../shared/services/permissions.service";

@Component({
  selector: "highlight-wrapper",
  templateUrl: "./highlight-wrapper.component.html",
  styleUrls: ["./highlight-wrapper.component.scss"]
})
export class HighlightWrapperComponent implements OnInit {
  @Input() PERMISSIONS = [];
  @Input() TITLES = [];
  @Input() APIS = [];
  @Input() TEXTS = [];
  @Input() COLUMNSIZE = 6;
  @Input() URLPARAMS = [];
  deviceWidth = window.innerWidth;

  constructor(private WIDGET_PERMISSIONS: PermissionUrlService) {}

  ngOnInit() {}
}
